//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'coupon',
  components: {
  },
  data () {
    return {
      list:[],
    }
  },
  created(){
    this.communityCoupon();
  },
  mounted(){
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  
  },
  methods:{
    communityCoupon(){
      this.$api.communityCoupon({}).then((res)=>{
        if(res){
          this.list = res.data;
        } 
      })  
    },
    give(id){
      this.$router.push({name:'giveCoupon',params:{id:id}});
    },
    qrCoupon(id){
      this.$router.push({name:'qrCoupon',params:{id:id}});
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/coupon.vue